/**
 * 帮助反馈相关接口
 * - 前台：提交反馈 / 我的反馈列表（含处理状态）
 * - 后台：管理端反馈列表 / 确定完成反馈
 */
import request from './request'

/**
 * 用户提交反馈
 * @param {{no:string, name:string, content:string}} data
 */
export function addFeedback(data) {
  return request.post('/feedback/add', data)
}

/**
 * 我的反馈列表（分页）
 * @param {{no:string, pageNum:number, pageSize:number}} data
 */
export function myFeedbacks(data) {
  return request.post('/feedback/myList', data)
}

/**
 * 管理端反馈列表（分页）
 * @param {{pageNum:number, pageSize:number, param:{keyword?:string}}} data
 */
export function manageFeedbacks(data) {
  return request.post('/feedback/manageList', data)
}

/**
 * 管理员确定完成反馈
 * @param {{id:number, operatorRole:number, operatorNo:string, operatorName:string}} data
 */
export function finishFeedback(data) {
  return request.post('/feedback/finish', data)
}
